/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResolutionMetadata
 */
export interface ResolutionMetadata {
    /**
     * 
     * @type {string}
     * @memberof ResolutionMetadata
     */
    resolutionId?: string;
    /**
     * 
     * @type {string}
     * @memberof ResolutionMetadata
     */
    resolutionMethod?: string;
    /**
     * 
     * @type {Date}
     * @memberof ResolutionMetadata
     */
    resolutionTimestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof ResolutionMetadata
     */
    resolvedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof ResolutionMetadata
     */
    totalControlsProcessed?: number;
    /**
     * 
     * @type {number}
     * @memberof ResolutionMetadata
     */
    controlsIncluded?: number;
    /**
     * 
     * @type {number}
     * @memberof ResolutionMetadata
     */
    controlsExcluded?: number;
    /**
     * 
     * @type {number}
     * @memberof ResolutionMetadata
     */
    controlsModified?: number;
    /**
     * 
     * @type {number}
     * @memberof ResolutionMetadata
     */
    organizationalValuesApplied?: number;
}

/**
 * Check if a given object implements the ResolutionMetadata interface.
 */
export function instanceOfResolutionMetadata(value: object): value is ResolutionMetadata {
    return true;
}

export function ResolutionMetadataFromJSON(json: any): ResolutionMetadata {
    return ResolutionMetadataFromJSONTyped(json, false);
}

export function ResolutionMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolutionMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'resolutionId': json['resolutionId'] == null ? undefined : json['resolutionId'],
        'resolutionMethod': json['resolutionMethod'] == null ? undefined : json['resolutionMethod'],
        'resolutionTimestamp': json['resolutionTimestamp'] == null ? undefined : (new Date(json['resolutionTimestamp'])),
        'resolvedBy': json['resolvedBy'] == null ? undefined : json['resolvedBy'],
        'totalControlsProcessed': json['totalControlsProcessed'] == null ? undefined : json['totalControlsProcessed'],
        'controlsIncluded': json['controlsIncluded'] == null ? undefined : json['controlsIncluded'],
        'controlsExcluded': json['controlsExcluded'] == null ? undefined : json['controlsExcluded'],
        'controlsModified': json['controlsModified'] == null ? undefined : json['controlsModified'],
        'organizationalValuesApplied': json['organizationalValuesApplied'] == null ? undefined : json['organizationalValuesApplied'],
    };
}

export function ResolutionMetadataToJSON(json: any): ResolutionMetadata {
    return ResolutionMetadataToJSONTyped(json, false);
}

export function ResolutionMetadataToJSONTyped(value?: ResolutionMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resolutionId': value['resolutionId'],
        'resolutionMethod': value['resolutionMethod'],
        'resolutionTimestamp': value['resolutionTimestamp'] == null ? undefined : ((value['resolutionTimestamp']).toISOString()),
        'resolvedBy': value['resolvedBy'],
        'totalControlsProcessed': value['totalControlsProcessed'],
        'controlsIncluded': value['controlsIncluded'],
        'controlsExcluded': value['controlsExcluded'],
        'controlsModified': value['controlsModified'],
        'organizationalValuesApplied': value['organizationalValuesApplied'],
    };
}

